import type { ApolloClient } from '@apollo/client';

/*
 * Drops events from the normalised cache, so every list holding a ref to them updates at once.
 * Lives in the store rather than beside the events routes because the app-wide events socket needs
 * it too, and the store must not import from a route.
 */
export const evictEventsFromCache = (client: ApolloClient<unknown>, eids: number[]): void => {
  eids.forEach((eid) => {
    client.cache.evict({
      id: client.cache.identify({
        eid: `${eid}`,
        __typename: 'AssetWithEvent'
      })
    });
  });

  client.cache.gc();
};
